var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBiometric = function SvgBiometric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 3.778v3.889h1.6V4.556h3.2V3h-4a.812.812 0 0 0-.566.228.767.767 0 0 0-.234.55Zm14.4 3.889v-3.89a.767.767 0 0 0-.234-.55A.812.812 0 0 0 16.4 3h-4v1.556h3.2v3.11h1.6Zm-1.6 7.777h-3.2V17h4a.812.812 0 0 0 .566-.228.767.767 0 0 0 .234-.55v-3.889h-1.6v3.111ZM7.6 17v-1.556H4.4v-3.11H2.8v3.888c0 .206.084.404.234.55.15.146.354.228.566.228h4ZM2 9.222h16v1.556H2V9.222Z",
    fill: "#666"
  })));
};
export default SvgBiometric;